import { Component, ojs, app } from "modular-openscriptjs";

const h = app("h");

export default class FeedProductsHolder extends Component {
	render(...args) {
		return h.div(...args);
	}
}
